const vuexModules = {
    namespaced: true,
    state: {
        targetDate: '',
        targetGolf: '',
        targetMonth: '',
        targetYear: ''
    },
    mutations: {
        setTargetDate (state, targetDate) {
            state.targetDate = targetDate;
        },
        setTargetGolf (state, targetGolf) {
            state.targetGolf = targetGolf;
        },
        setTargetYear (state, targetYear) {
            state.targetYear = targetYear;
        },
        setTargetMonth (state, targetMonth) {
            state.targetMonth = targetMonth;
        }
    }
};

export default vuexModules;
